/**
 * PDP Clinical Trials tabs (Rhode-style). Scoped custom element.
 */
if (!customElements.get('pdp-clinical-trials')) {
  class PdpClinicalTrials extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.tab));
        tab.addEventListener('keydown', (e) => this.onKey(e));
      });
    }

    onKey(e) {
      const i = this.tabs.indexOf(e.currentTarget);
      if (i < 0) return;
      let next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        next = this.tabs[(i + 1) % this.tabs.length];
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        next = this.tabs[(i - 1 + this.tabs.length) % this.tabs.length];
      } else if (e.key === 'Home') {
        next = this.tabs[0];
      } else if (e.key === 'End') {
        next = this.tabs[this.tabs.length - 1];
      }
      if (next) {
        e.preventDefault();
        next.focus();
        this.select(next.dataset.tab);
      }
    }

    select(id) {
      if (!id) return;
      this.setAttribute('data-selected', id);
      this.tabs.forEach((tab) => {
        const on = tab.dataset.tab === id;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        const on = panel.dataset.panel === id;
        panel.classList.toggle('is-active', on);
        if (on) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }
  }
  customElements.define('pdp-clinical-trials', PdpClinicalTrials);
}
